import { IFrame } from '../../types'

interface IFramesState {
  iframesRendered: {
    id?: IFrame
  }
  playingIFrameId: string
}

const state: IFramesState = {
  iframesRendered: {},
  playingIFrameId: '',
}

export { IFramesState, state }
